import { User } from 'firebase/auth';
import { UserDocument } from 'models/user';
const STAFF_EMAIL_DOMAIN = '@mxlocker.com';

/**
 * True when the user has a verified phone number, had the phone step bypassed
 * (userDoc.phone === 'SKIP'), or is staff. Staff sign in with Google on a
 * company account (enforced server-side in beforeSignIn), so they skip the
 * phone verification step.
 */
export const isPhoneAuthenticated = (
  user?: Pick<User, 'phoneNumber' | 'email'> | null,
  userDoc?: Pick<UserDocument, 'phone'> | null
) =>
  !!user?.phoneNumber ||
  userDoc?.phone === 'SKIP' ||
  !!user?.email?.toLowerCase().endsWith(STAFF_EMAIL_DOMAIN);
